import client from './client';

export default {
  async getAgeTypes() {
    const response = await client.get('age-types/');
    return response.data;
  },

  async getDegreeTypes() {
    const response = await client.get('degree-types/');
    return response.data;
  },

  async getDegreeMajorTypes() {
    const response = await client.get('degree-major-types/');
    return response.data;
  },

  async getGenderTypes() {
    const response = await client.get('gender-types/');
    return response.data;
  },

  async getEthnicityTypes() {
    const response = await client.get('ethnicity-types/');
    return response.data;
  },

  async getIndustryTypes() {
    const response = await client.get('industry-types/');
    return response.data;
  },

  async getFunctionalAreaTypes() {
    const response = await client.get('functional-area-types/');
    return response.data;
  },

  async getCoachExpTypes() {
    const response = await client.get('coach-exp-types/');
    return response.data;
  },

  async getCoachingCertTypes() {
    const response = await client.get('coaching-cert-types/');
    return response.data;
  },

  async getCorpWorkExpTypes() {
    const response = await client.get('corp-work-exp-types/');
    return response.data;
  },

  async getOrgLvlTypes() {
    const response = await client.get('org-lvl-types/');
    return response.data;
  },
};
